export const REGISTER_PAGE = Object.freeze({
  LOADING: 'LOADING',
  REGISTER_CHECK_FORM: 'REGISTER_CHECK_FORM',
  REGISTER_FORM: 'REGISTER_FORM',
  OAUTH_COMPLETE_FORM: 'OAUTH_COMPLETE_FORM',
  CONSENT_FORM: 'CONSENT_FORM',
});